import{jsx as e}from"react/jsx-runtime";import{forwardRef as r}from"react";import{twMerge as t}from"tailwind-merge";function o(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function n(e,r){if(null==e)return{};var t,o,n=function(e,r){if(null==e)return{};var t,o,n={},l=Object.keys(e);for(o=0;o<l.length;o++)t=l[o],r.indexOf(t)>=0||(n[t]=e[t]);return n}
/**
 * 기본 입력 필드 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 props
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {boolean} [props.isError] - 에러 상태 표시 여부
 * @param {boolean} [props.isFocused] - 포커스 상태 표시 여부
 * @param {boolean} [props.disabled] - 비활성화 상태 여부
 *
 * @extends {InputHTMLAttributes<HTMLInputElement>} HTML input 요소의 기본 속성들을 모두 지원합니다.
 *
 * @example
 * // 기본 사용
 * <Input placeholder="텍스트를 입력하세요" />
 *
 * // 비활성화 상태
 * <Input disabled placeholder="입력할 수 없습니다" />
 *
 * // 커스텀 클래스 적용
 * <Input className="custom-input" placeholder="커스텀 스타일" />
 *
 * // 에러 상태
 * <Input isError placeholder="에러 상태" />
 */(e,r);if(Object.getOwnPropertySymbols){var l=Object.getOwnPropertySymbols(e);for(o=0;o<l.length;o++)t=l[o],r.indexOf(t)>=0||Object.prototype.propertyIsEnumerable.call(e,t)&&(n[t]=e[t])}return n}const l=/*#__PURE__*/r(((r,l)=>{var{disabled:a,className:i,isError:c,isFocused:u}=r,s=n(r,["disabled","className","isError","isFocused"]);/*#__PURE__*/
return e("input",function(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{},n=Object.keys(t);"function"==typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(t).filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})))),n.forEach((function(r){o(e,r,t[r])}))}return e}({role:"text-input",ref:l,className:t("w-full tracking-default text-w-gray-600 outline-none typo-body1 placeholder:tracking-default placeholder:text-w-gray-300 placeholder:typo-body1 disabled:bg-w-gray-10",a&&"cursor-not-allowed text-w-gray-300 placeholder:text-w-gray-200 placeholder:typo-body1",i),"data-testid":"design-system--input",disabled:a},s))}));l.displayName="Input";export{l as Input};
